import React from 'react';
import { Modal } from 'antd';
import PropTypes from 'prop-types';
import { LocalizationContext } from '../../../hoc/Localization';
import { getCookie } from '../../../utils/cookies';
import api from '../../../utils/api';
import styles from './styles.less';
import SubscribeComponent from '../../TinyComponents/SubscribeComponent';

const ModalSubscribe = ({ user, course, modalShow }) => {
    const [visible, setVisible] = React.useState(false);
    const [smallScreen, setSmallScreen] = React.useState(false);
    const [courseSubscribed, setCourseSubscribe] = React.useState(false);
    const [subscribed, setSubscribed] = React.useState(true);
    const { t, locale } = React.useContext(LocalizationContext);

    React.useEffect(() => {
        api.get(`user-subscriptions/is-subscribed?userTrackingId=${getCookie('sync')}`)
            .then(res => {
                const { isSubscribed } = res;
                setSubscribed(isSubscribed);
                setCourseSubscribe(sessionStorage.getItem('SubscribeCourse'));
            })
            .catch(() => null);
    }, [user]);

    React.useEffect(() => {
        if (!subscribed && !courseSubscribed && modalShow) {
            setVisible(true);
        }
    }, [subscribed, courseSubscribed, modalShow]);

    React.useEffect(() => {
        const windowWidth = window.screen.width;
        if (windowWidth < 768) {
            setSmallScreen(true);
        }
    }, []);

    const hideModal = () => {
        sessionStorage.setItem('SubscribeCourse', false);
        setVisible(false);
    };
    function showModal(status) {
        if (status === 'success') {
            setTimeout(() => {
                hideModal();
            }, 4000);
        }
    }

    return (
        <Modal
            visible={visible}
            style={{ padding: '0px' }}
            onCancel={hideModal}
            maskClosable={false}
            footer={null}
            bodyStyle={{ padding: '0' }}
            width="845px"
            centered
            closeIcon={
                !smallScreen ? (
                    <img src="/static/images/course/closeModal.svg" alt="close" />
                ) : (
                    <img
                        className={styles.closeButton}
                        src="/static/images/course/closeModalWhite.svg"
                        alt="close"
                    />
                )
            }
            className={styles.subscribeCoursesModal}
        >
            <div className={styles.subscribeModalContainer}>
                <div className={styles.imageWrapper}>
                    <img alt="img" src={course.category.thumbnailUrl} />
                    <div className={styles.textWrapper}>
                        <h2>{course.category[`subscribe_popup_title_${locale}`]}</h2>
                    </div>
                </div>
                <div className={styles.subscribeWrapper}>
                    <h2>{t('email.popup.text.headline')}</h2>
                    <p>{course.category[`subscribe_popup_text_${locale}`]}</p>
                    <SubscribeComponent
                        subscribeButtonType="primary"
                        course={course}
                        user={user}
                        closeModal={status => showModal(status)}
                        subscribeName="subscribeModal"
                        pageSuffix="_popup"
                    />
                </div>
            </div>
        </Modal>
    );
};
ModalSubscribe.propTypes = {
    course: PropTypes.object,
    user: PropTypes.object,
    modalShow: PropTypes.bool,
};
ModalSubscribe.defaultProps = {
    course: {},
    user: {},
    modalShow: false,
};
export default ModalSubscribe;
